export default __webpack_public_path__ + "img/961d837276c55e485259c4660b4844f8.jpg";